const RenderSection = ({componentsMap = {}, conditionMap = {}, componentName = ''}) => {
  const Component = componentsMap[componentName];
  const {renderCondition = true, props = {}} = conditionMap[componentName] || {};

  if (Component && !!renderCondition) {
    return <Component {...props} />;
  }
  return null;
};

export default RenderSection;
